export const ErrorStrings = {
  chipNumberInvalid:      'Chip number must be 15 characters',
  emailInvalid:           'Email address is not valid',
  emailMustEndWith:       'Email address must end with .com, .co.uk or .co.ie',
  emailMismatch:          'Email addresses do not match',
  passwordMismatch:       'Passwords do not match',
  passwordTooShort:       'Password is too short',
  required:               'This field is required',
  telephoneInvalid:       'Telephone number is not valid',
  telephoneMismatch:      'Telephone numbers do not match',
  telephoneTooShort:      'Telephone number too short',
  vetCodeInvalid:         'Vet code must be 6 characters',
  invalidDateForm:        'Please enter a valid date (dd/mm/yyyy)',
  invalidEndDateRange:    'The end date cannot be before the start date',
  invalidStartDateRange:  'The start date cannot be after the end date',
};

export const ValidationPatterns = {
  telephone: '\\s*(((\\+{1}|00)\\d{1,3}-?)|0)\\s*(?:\\d\\s*){10}$'
};

export const UserTitles: Array<string> = [
  'Mr',
  'Mrs',
  'Ms',
  'Miss',
  'Mx',
  'Dr'
];

export const Genders: Array<string> = [
  'Male',
  'Female',
  'I prefer not to say'
];
